import { ISideNavigationItem } from "interfaces/sideNavigationItem";

export interface IRightsModel {
  getPlan(): string;
  hasRight(right: string): boolean;
}

function mapItemByRights(item: ISideNavigationItem, rights: IRightsModel): ISideNavigationItem | null {
  if (item.plan) {
    const plan: string[] = Array.isArray(item.plan) ? item.plan : [item.plan];
    if (!plan.includes(rights.getPlan())) {
      return null;
    }
  }

  if (item.right) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (rights[item.right]) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (!rights[item.right]()) {
        return null;
      }
    } else if (!rights.hasRight(item.right)) {
      return null;
    }
  }

  if (item.children) {
    return {
      ...item,
      children: item.children
        .map(childItem => mapItemByRights(childItem, rights))
        .filter((childItem): childItem is ISideNavigationItem => childItem !== null),
    };
  }

  return item;
}

export function filterItemsByRights(items: ISideNavigationItem[], rights: IRightsModel): ISideNavigationItem[] {
  return items.map(item => mapItemByRights(item, rights)).filter((item): item is ISideNavigationItem => item !== null);
}

export interface IActiveItems {
  activeItem: ISideNavigationItem;
  activeParentItem: ISideNavigationItem;
}

/**
 * Find both parent & child items according to tree structure
 * that leads to an item with id={activeItemId}
 */
export function getActiveItems(items: ISideNavigationItem[], activeItemId: string): IActiveItems {
  if (activeItemId === undefined) {
    // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'ISideNaviga... Remove this comment to see the full error message
    return { activeItem: null, activeParentItem: null };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let activeItem: any = null;
  let activeParentItem = null;

  activeParentItem = items.find(parentItem => parentItem.id === activeItemId);
  if (activeParentItem) {
    activeItem = activeParentItem;
  } else {
    items.some(parentItem => {
      if (parentItem.children) {
        activeItem = parentItem.children.find(childItem => childItem.id === activeItemId);
        if (activeItem) {
          activeParentItem = parentItem;
        }
      }
      return activeItem;
    });
  }

  // @ts-expect-error TS(2322): Type 'ISideNavigationItem | undefined' is not assi... Remove this comment to see the full error message
  return { activeItem, activeParentItem };
}
